import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, Slide, Typography } from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { blue } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { forwardRef } from "react";
import { formatIndianPhone } from "../client/client_halper";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function EmployeeDetails({ data, handleClose }) {
    const navigate = useNavigate();
    if (data === null) return (<></>);
    return (
        <Dialog open={data !== null} onClose={handleClose} TransitionComponent={Transition} keepMounted>
            <DialogTitle variant="h5" color="info">{data.name} <Typography variant="caption">{data.designation}</Typography></DialogTitle>
            <DialogContent>
                <Grid container spacing={0.5}>
                    <Grid size={{ xs: 6, sm: 6 }}>
                        <Typography variant="subtitle2">{data.user_id} <Chip label={"Account: " + data.account} variant="filled" size="small" color="success" /> </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6 }} textAlign={"right"}>
                        <Typography variant="subtitle2">{data.created}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2" component={"a"} href={"tel:" + data.phone} className="align_text"><PhoneIcon fontSize="small" /> {formatIndianPhone(data.phone)}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2" component={"a"} href={"mailto:" + data.email} className="align_text"><EmailIcon fontSize="small" /> {data.email ?? "NA"}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Joining: {data.doj}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">{data.doe === null ? "Currently Working" : "Exit: " + data.doe}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption"> Accounts</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Typography variant="body2">Balance: {data.balance}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Opening Date: {data.opening_date}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Opening Balance: {data.opening_balance}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Identity Document</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Aadhar: <Link href={data.aadhar_scanned}>{data.aadhar ?? "Not Uploaded"}</Link></Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">PAN: <Link href={data.pan_scanned}>{data.pan ?? "Not Uploaded"}</Link></Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Voter: <Link href={data.voter_scanned}>{data.voter_card ?? "Not Uploaded"}</Link></Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Compliance</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Licence: <Link href={data.driving_scanned}>{data.driving ?? "Not Uploaded"}</Link></Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Valid From: {data.driving_valid_from}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Expiry: {data.driving_valid_end}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Address</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Typography variant="body2">{data.address ?? "NA"}</Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ pb: 3, px: 3 }}>
                {data.doe === null ? <Button disabled variant="contained" color="warning">Separation</Button> : ""}
                <Button variant="outlined" disabled color="info" onClick={(e) => { navigate("/employee/details/" + data.user_id) }}>Edit</Button>
                <Button variant="outlined" onClick={handleClose} autoFocus>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

export default EmployeeDetails;